import React, { useState } from "react";
import { AdvancingTemplateState, type TemplateFormGroup } from "./model";
import { EditSectionTemplate } from "components/MainSectionTemplate/EditSectionTemplate";
import { routes } from "utilities/routing/generatedRoutes";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import { TemplateEditForm, getTemplateRows } from "./components/TemplateEditForm";

interface AdvancingTemplateDetailSectionProps {
  advancingTemplate: server.dto.AdvancingTemplate
  formGroups: TemplateFormGroup[]
}

export const AdvancingTemplateDetailSection = (props: AdvancingTemplateDetailSectionProps) => {
  const [advancingTemplate, setAdvancingTemplate] = useState<AdvancingTemplateState>({
    name: props.advancingTemplate.name,
    formGroups: props.formGroups
  });

  const submit = () => {
    return window.CoreApi.AdvancingTemplate.Update({
      advancingTemplateId: props.advancingTemplate.advancingTemplateId,
      name: advancingTemplate.name,
      rows: getTemplateRows(advancingTemplate.formGroups)
    })
  }

  // TODO: Here we are using the EditTemplate as well. We should refactor this
  //  to use the detail template sometime in the future.
  return <EditSectionTemplate
    submit={submit}
    redirectUrl={() => routes.advancingTemplate_List().absolute}
    sections={[{
      key: "advancingTemplate",
      type: "regular",
      title: RESX.Advancing.AdvancingTemplate,
      fields: [{
        key: "name",
        hideLabel: true,
        label: RESX.GeneralLabels.Name,
        renderEditNew: () => <div style={{
          paddingLeft: 8,
        }}><RequiredTextInput
            validatorKey="title"
            focusOnMount
            maxLength={serverReference.constants.advancingTemplate.maxNameLength}
            value={advancingTemplate.name}
            onChange={(name) => { setAdvancingTemplate({ ...advancingTemplate, name }); }}
          />
        </div>
      }, {
        key: "formSections",
        hideLabel: true,
        label: "",
        renderEditNew: () => <div style={{
          paddingLeft: 8,
        }}>
          <TemplateEditForm
            formGroups={advancingTemplate.formGroups}
            onChange={formGroups => setAdvancingTemplate({ ...advancingTemplate, formGroups })}
          />
        </div>
      }]
    }]}
  />
}